import React, { ReactNode } from 'react';
import { HeadlineInfo } from './HeadlineInfo';
import { GetHeadlineAndPosition, HeadlineType } from '../BlockInteractionsTypes';

type BlockInteractionsInfoType = {
  isInLayoutGroup?: boolean;
  headline: HeadlineType;
  headingRef: React.RefObject<HTMLHeadingElement | null>;
  info?: ReactNode;
  getHeadlinePosition: GetHeadlineAndPosition;
};

export function BlockInteractionsInfo({
  isInLayoutGroup,
  headline,
  headingRef,
  info,
  getHeadlinePosition,
}: BlockInteractionsInfoType) {
  return (
    <div className="block-interactions__info">
      <HeadlineInfo
        isInLayoutGroup={isInLayoutGroup}
        headline={headline}
        headingRef={headingRef}
        info={info}
        getHeadlinePosition={getHeadlinePosition}
      />
    </div>
  );
}
